import React from 'react';
import { styles } from './styles';
import { withStyles, StyledComponentProps, Typography } from '@material-ui/core';
import { MenuTrainers } from '../../ui-components/Icons';

const trainers = (props: StyledComponentProps) => {
    return (<div className={props.classes.root}>
        <MenuTrainers className={props.classes.subHeaderIcon} />
        <Typography className={props.classes.title} variant='h6'>Istruttori</Typography>
    </div>)
}

export const Trainers = withStyles(styles)(trainers)